module.exports = __webpack_public_path__ + "img/speaker-ClarenceSeedorf.7503f5e2.png";